import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const StyledLine = styled.line`
  stroke: ${tokens.color.ui_disabled};
  stroke-width: 2;
`;

export const CornerLine = (): JSX.Element => {
  return (
    <svg height="36" width="23">
      <StyledLine x1="1" y1="0" x2="1" y2="19" />
      <StyledLine x1="1" y1="18" x2="23" y2="18" />
    </svg>
  );
};
